var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransporter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "430 -102.6 22.5 42.2",
    enableBackground: "new 430 -102.6 22.5 42.2",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -371.8,
    y: -345,
    width: 969.8,
    height: 713.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.94
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M444.6-96.6c0,1.8-1.5,3.3-3.3,3.3l0,0c-1.8,0-3.3-1.5-3.3-3.3l0,0c0-1.8,1.5-3.3,3.3-3.3l0,0 C443.1-99.9,444.6-98.4,444.6-96.6L444.6-96.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M441.5-92.8c0,0,3.3,0.6,4.7,0.6c1.4,0,1.4,1,1.4,1l1.2,10.8c0,0,0.3,1-1.3,1.1c0,0-1.2,0-1.3-1.2l-1.1-8 h-0.3l0.6,24.3c0,0-0.2,1-1.5,1c-2.2,0-1.8-1-1.8-1l-0.6-13.4H441l-0.6,13.4c0,0,0.4,1-1.8,1c-1.2,0-1.5-1-1.5-1l0.6-24.3h-0.3 l-1.1,8c-0.1,1.2-1.3,1.3-1.3,1.3c-1.6-0.1-1.3-1.2-1.3-1.2l1.2-10.8c0,0,0-1,1.4-1s4.7-0.6,4.7-0.6H441.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 511.5,
    y: 370.4,
    width: 75.1,
    height: 29.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -3.051758e-05)",
    clipPath: "url(#SVGID_4_)"
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 1710,
    height: 1276,
    xlinkHref: "Screen Shot 2014-08-07 at 1.16.05 PM.png",
    transform: "matrix(0.6175 0 0 0.6175 -345.4637 -358.1656)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol_4"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol_3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransporter);
export default __webpack_public_path__ + "static/media/transporter.7d085bacb292a979ec211f51e9e8bd2b.svg";
export { ForwardRef as ReactComponent };